'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.millisecondsUntil;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/millisecondsUntil.js
// module id = 572
// module chunks = 0